// En este fichero defeniremos los IDs de las acciones de nuestros plugins.
export const FACEBOOK_PLUGIN_ID = "15550f37-7d19-40fd-98cb-f59353f6687e";
export const FACEBOOK_ACTION_GET_FORMS = "8456cdd8-e43d-4a0e-be1c-95b86501a8d9";
export const FACEBOOK_ACTION_GET_PAGES = "17947b76-3a35-483b-b413-31732da9ec34";
export const FACEBOOK_ACTION_GET_FIELDS = "e373467e-2ba6-40d3-808e-892d68a28ad6";
export const FACEBOOK_ACTION_GET_LEAD = "49e8c3a5-75af-4a58-a706-f9bc47561c34";
export const BREVO_ACTION_WEBHOOK_GET_STATS = "22d0da6e-dd67-4f00-b3e2-493234403d7e";
export const ZOHO_ACTIONS_WEBHOOKS = {
    Leads: "984a4c9e-37aa-4783-9869-0350fa2c1fc6",
    Contacts: "f163c5ec-7c6b-446e-bc39-181e4c54e054",
    Calls: "767bcde2-6ea1-4eb5-911a-4f2ef1672645",
    Deals: "f57218e1-0338-4235-a360-b4dea8c3a902",
    Sales_Orders: "bfc466c8-eb45-4f3b-bfa4-9c5aaf6e5e03",
};
export const ZOHO_ACTION_GET_FIELDS = "aa9b36fb-bb64-4e93-ab29-203c222b458b";
export const ZOHO_ACTION_GET_FIELDS_LG = "71076714-e317-4b31-836c-e61dcf87094a";